import { createAllIdsReducer } from 'store/redux';

import * as actionTypes from './actionTypes';

export default createAllIdsReducer({
  key: 'fundingInfoInternational',
  types: actionTypes.SUCCESS,
});
